import { CHANGE_CONFIRM, CHANGE_PHONE_NUMBER, CHANGE_OTP, CHANGE_OTP_SUCCESS, CHANGE_PASSWORD, ERROR_CONFIRM_PASSWORD, ERROR_PHONE_NUMBER, ERROR_OTP, INITIAL_STATE, RESEND_OTP, SUBMIT_BACK, SUBMIT_PHONE_NUMBER, SUBMIT_ONPROGRESS, SUBMIT_OTP, SUBMIT_PASSWORD, CHANGE_SHOW_PASSWORD, CHANGE_SHOW_CONFIRM, CHANGE_NAME, CHANGE_EMAIL, CHANGE_DOB, CHANGE_NIK, SUBMIT_INFO, ERROR_NAME, ERROR_EMAIL, ERROR_DOB, ERROR_NIK } from "./types";

const initiate = {
    phoneNumber: "",
    otp: "",
    name: "",
    email: "",
    dob: "",
    nik: "",
    password: "",
    confirmPassword: "",
    errorPhoneNumber: "",
    errorOtp: "",
    errorName: "",
    errorEmail: "",
    errorDob: "",
    errorNik: "",
    errorPassword: "",
    errorConfirm: "",
    showPassword: false,
    showConfirmPassword: false,
    isSubmitedForgot: false,
    successResend: false,
    submitSuccess: false,
    validation: {
        minChar: false,
        capitalChar: false,
        lowerChar: false,
        numberChar: false,
    },
    step: 0,
    tempToken: "",
}

const Register = (state = initiate, action) => {
    switch (action.type) {
        case INITIAL_STATE:
            state = initiate;

            return state;
        case CHANGE_PHONE_NUMBER:
            return {
                ...state,
                phoneNumber: action.payload
            }
        case CHANGE_OTP:
            return {
                ...state,
                otp: action.payload,
                errorOtp: ""
            }
        case CHANGE_NAME:
            return {
                ...state,
                name: action.payload
            }
        case CHANGE_EMAIL:
            return {
                ...state,
                email: action.payload
            }
        case CHANGE_DOB:
            return {
                ...state,
                dob: action.payload
            }
        case CHANGE_NIK:
            return {
                ...state,
                nik: action.payload
            }
        case CHANGE_PASSWORD:
            return {
                ...state,
                ...action.payload
            }
        case CHANGE_CONFIRM:
            return {
                ...state,
                confirmPassword: action.payload
            }
        case CHANGE_OTP_SUCCESS:
            return {
                ...state,
                successResend: false
            }
        case CHANGE_SHOW_PASSWORD:
            return {
                ...state,
                showPassword: !action.payload
            }
        case CHANGE_SHOW_CONFIRM:
            return {
                ...state,
                showConfirmPassword: !action.payload
            }
        case ERROR_PHONE_NUMBER:
            return {
                ...state,
                isSubmitedForgot: false,
                errorPhoneNumber: action.payload
            }
        case ERROR_OTP:
            return {
                ...state,
                isSubmitedForgot: false,
                errorOtp: action.payload
            }
        case ERROR_NAME:
            return {
                ...state,
                isSubmitedForgot: false,
                errorName: action.payload
            }
        case ERROR_EMAIL:
            return {
                ...state,
                isSubmitedForgot: false,
                errorEmail: action.payload
            }
        case ERROR_DOB:
            return {
                ...state,
                isSubmitedForgot: false,
                errorDob: action.payload
            }
        case ERROR_NIK:
            return {
                ...state,
                isSubmitedForgot: false,
                errorNik: action.payload
            }
        case ERROR_CONFIRM_PASSWORD:
            return {
                ...state,
                errorConfirm: action.payload,
                isSubmitedForgot: false,
            }
        case RESEND_OTP:
            return {
                ...state,
                successResend: true
            }
        case SUBMIT_ONPROGRESS:
            return {
                ...state,
                isSubmitedForgot: true,
                errorPhoneNumber: "",
                errorName: "",
                errorDob: "",
                errorEmail: "",
                errorNik: "",
                errorOtp: "",
                errorPassword: "",
                errorConfirm: ""
            }
        case SUBMIT_BACK:
            return {
                ...state,
                step: state.step - 1
            }
        case SUBMIT_OTP:
            return {
                ...state,
                isSubmitedForgot: false,
                step: state.step + 1,
                otp: ""
            }
        case SUBMIT_PASSWORD:
            let step = state.step + 1;
            state = initiate;

            return {
                ...state,
                isSubmitedForgot: false,
                step: step
            }
        case SUBMIT_INFO:
            return {
                ...state,
                isSubmitedForgot: false,
                step: state.step + 1
            }
        case SUBMIT_PHONE_NUMBER:
            return {
                ...state,
                isSubmitedForgot: false,
                tempToken: action.payload,
                step: state.step + 1
            }
        default:
            return state;
    }
}

export default Register;